export enum ITEM_TYPE {
  SINGLE = 'single',
  SERVICE = 'service',
  PACKAGE = 'package'
};